<template>
    <div class="contact">
        <div class="contact-bg">
            <div class="contact-bg-img">
                <img src="@/assets/contact/banner.png" alt="">
            </div>
            <div class="contact-bg-breadcrumb">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/">{{ $t('technology.breadcrumb.title') }}</a></li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t('footer.contact.title') }}</li>
                    </ol>
                </nav>
            </div>
            <div class="contact-bg-position"></div>
            <div class="pc-fixed-icon" @click="openInquiryForm">
                <img src="@/assets/home/xinxi.png" alt="">
            </div>
        </div>
        <div class="contact-us">
            <div class="area-title-pc" style="padding-top:0%">{{ $t('content.title') }}</div>
            <div class="contact-us-content">
                <div>
                    <div class="contact-us-info">
                        <div class="contact-us-info-tip">{{ $t('content.info.tip') }}</div>
                        <div class="flex contact-us-info">
                            <img src="@/assets/contact/phone.png" alt="">
                            <div>{{ contactList?.mobile }}</div>
                        </div>
                        <div class="flex contact-us-info">
                            <img src="@/assets/contact/address.png" alt="">
                            <div>{{ contactList?.address }}</div>
                        </div>
                        <div class="flex contact-us-info">
                            <img src="@/assets/contact/email.png" alt="">
                            <div>{{ contactList?.email }}</div>
                        </div>
                        <div class="follow-us">
                            <div class="follow-us-title">{{ $t('content.follow.title') }}</div>
                            <div class="social-links">
                                <a :href="contactList?.facebook">
                                    <img src="@/assets/bottom-f.png" alt="">
                                </a>
                                <a :href="contactList?.twitter">
                                    <img src="@/assets/bottom-p.png" alt="">
                                </a>
                                <a :href="contactList?.linkedIn">
                                    <img src="@/assets/bottom-in.png" alt="">
                                </a>
                                <a :href="contactList?.instagram">
                                    <img src="@/assets/bottom-x.png" alt="">
                                </a>
                                <span></span>
                            </div>
                        </div>
                    </div>
                    <el-form ref="form" :model="formData" size="mini">
                        <div class="form-title">{{ $t('content.follow.form.title') }}</div>
                        <el-form-item :label="$t('content.follow.form.label.know')" label-position="top">
                            <el-select size="100%" v-model="formData.know" :placeholder="$t('error.select')">
                                <el-option v-for="value in queryList" :key="value.id" :label="value.name" :value="value.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item :label="$t('content.follow.form.label.identity')" label-position="top">
                            <el-select size="100%" v-model="formData.identity" :placeholder="$t('error.select')">
                                <el-option v-for="value in $t('content.follow.identityOPtions')" :key="value.value" :label="value.label" :value="value.label"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item :label="$t('content.follow.form.label.fullname')" label-position="top">
                            <el-input size="100%" v-model="formData.name" placeholder="Enter"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('content.follow.form.label.contact')" label-position="top">
                            <el-input size="100%" v-model="formData.contact" placeholder="Enter"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('content.follow.form.label.email')" label-position="top">
                            <el-input size="100%" v-model="formData.email" placeholder="Enter"></el-input>
                        </el-form-item>
                        <!-- <el-form-item class="form-tip" :label="$t('content.follow.form.label.solve')">
                            <el-checkbox-group v-model="formData.type" @change="handleCheckedChange">
                                <el-checkbox  v-for="value in checkData" :key="value.value" :label="value.name" :value="value.id" :name="value.name"></el-checkbox>
                                
                            </el-checkbox-group>
                        </el-form-item> -->
                        <el-form-item size="large">
                            <el-button class="custom-button" type="primary" @click="onSubmit">{{ $t('content.follow.form.buttonText') }}</el-button>
                        </el-form-item>
                        <!-- <div class="form-remark">{{ $t('content.follow.form.tips') }}</div> -->
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from '@/utils/bus'
import { getBannerListing,getConfigInformation,getQuestionType,getSolveOption,submitQuestion } from '@/api/komo'
export default {
    name: 'contact',
    data() {
        return {
            bannerList: [], //
            contactList: {},
            queryList: [],
            checkData:[],
            formData: {
                name: '',
                know: '',
                // identity:'',
                contact: '',
                email: '',
                // type: [],
                preferred_city:''
            }
        }
    },
    methods: {
        async initData () {
            const result = await getBannerListing('9');
            this.bannerList = result.data.list;

            // const contactDatalist = await getDataList(localStorage.getItem('pageId'));
            // this.contactList = contactDatalist.data.list;
            const contactDatalist = await getConfigInformation();
            this.contactList = contactDatalist.data;
        },
        async getFormData () {
            const queryResult = await getQuestionType();
            this.queryList = queryResult.data.list;

            // const checkList = await getSolveOption();
            // this.checkData = checkList.data.list
        },
        openInquiryForm(){
            bus.$emit('inquiry-form', true)
        },
        onSubmit() {
            console.log(this.formData)
            // 校验想知道什么
            if (!this.formData.know) {
                this.$message.error(this.$t('error.select'))
                return;
            }
            // 校验身份
            // if (this.formData.identity ===''|| this.formData.identity == null) {
            //     this.$message.error(this.$t('error.select'))
            //     return;
            // }
            // 校验名字
            if (!this.formData.name) {
                this.$message.error(this.$t('error.name'))
                return;
            }
            
            // 校验手机号
            if (!this.formData.contact) {
                this.$message.error(this.$t('error.phone'))
                return;
                    }
            if (!this.validatePhone(this.formData.contact)) {
                this.$message.error(this.$t('error.phoneFormat'))
                return;
            }
            
            // 校验邮箱
            if (!this.formData.email) {
                this.$message.error(this.$t('error.email'))
                return;
                    } 
            if (!this.validateEmail(this.formData.email)) {
                this.$message.error(this.$t('error.emailFormat'))
                return;
            }
            // 校验checkbox
            // if (!this.formData.type.length) {
            //     this.$message.error(this.$t('error.select'))
            //     return;
            // }
            let params = {
                question_type_id: this.formData.know,
                body_option: "consumer",
                // body_option: this.formData.identity === 0 ? "consumer" : "franchisee",
                full_name: this.formData.name,
                mobile: this.formData.contact,
                email: this.formData.email,
                preferred_city: this.formData.preferred_city,
                // problem: this.formData.type
            }
            submitQuestion(params).then(res => { 
                if (res.error == 0) {
                    this.$message.success(res.message);
                    //提交成功 重置表单
                    this.formData =  {
                        name: '',
                        know: '',
                        // identity:'',
                        contact: '',
                        email: '',
                        // type: [],
                        preferred_city:''
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        //验证手机号格式
		validatePhone(phone) {
			// 验证手机号是否为纯数字
			const numberRegex = /^1[34578]\d{9}$/;
			return numberRegex.test(phone);
        },
        //验证邮箱格式
        validateEmail(email) {
			const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
			return emailRegex.test(email);
		},
        handleCheckedChange(val) {
            console.log(val);
        }
    },
    async created() {
        await this.initData();
        await this.getFormData();
    },
}
</script>

<style scoped>
.contact {
    width: 100%;
    height: 100%;
    background: #F8F9FC;
    padding-bottom: 12vw;
}

.contact-bg {
    width: 100%;
    height: 100%;
    position: relative;
    padding-bottom: 2%;
}

.contact-bg-img {
    width: 100%;
    height: 580px;
}

.contact-bg-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.contact-bg-breadcrumb {
    width: 80%;
    height: 10%;
    background: #FFFFFF;
    box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
    border-radius: 60px;
    display: flex;
    align-items: center;
    padding-left: 3%;
    position: absolute;
    top: calc(580px - 5%);
    left: 10%;
    z-index: 1;
}

.contact-bg-breadcrumb .breadcrumb {
    margin: 0;
    font-size: 1.5rem;
}

.contact-bg-breadcrumb .breadcrumb a {
    color: #959595;
    text-decoration: none;
}

.contact-bg-breadcrumb .breadcrumb-item.active {
    font-weight: bold;
    color: #1E1E1E;
}
.contact-bg-position {
  width: 80%;
  margin: 5% auto 0;
  height: 46px;
  display: flex;
  justify-content: center;
  gap: 8%;
}
.contact-bg-information {
    position: fixed;
    bottom: 0%;
    right: 7%;
    width: 12vw;
    height: 12vw;
    cursor: pointer;
    z-index: 99;
}

.contact-bg-information img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.contact-us {
    width: 80%;
    background-color: #F8F9FC;
    margin: 0 auto;
}

.contact-us-title {
    color: #1E1E1E;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 56px;
    text-align: center;
    margin-bottom: 6%;
}

.contact-us-content {
    width: 80%;
    margin: 0 auto;
    justify-content: space-between;
}

form {
    min-width: 48%;
    margin-left: 4%;
    background: #FFFFFF;
    box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
    border-radius: 30px;
    flex: 1;
    padding: 0 4%;
}

.contact-us-content>div,
.flex {
    display: flex;
    line-height: 40px;
}

.contact-us-content>div {
    align-items: center;
}

.flex>div {
    font-family: MicrosoftYaHei;
    font-size: 1.2vw;
    color: #252323;
}

.contact-us-info>.contact-us-info {
    margin-bottom: 1vw;
}

.contact-us-info>.contact-us-info:last-child {
    margin-bottom: 1.2vw;
}

.contact-us-info img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
}

.contact-us-info-tip {
    font-family: MicrosoftYaHei;
    font-size: 1.2vw;
    color: #1E1E1E;
    margin-bottom: 40px;
    text-align: center;
}

.follow-us-title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 1.2vw;
    color: #252323;
    line-height: 40px;
    margin-bottom: 1.2vw;
}

.follow-us>img {
    width: 36px;
    height: 36px;
    margin-right: 20px;
}

.divider-color {
    width: 15%;
    background-color: #1E1E1E;
}
:deep(.el-checkbox__input.is-checked .el-checkbox__inner),:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner){
  background-color: #1e1e1e;
  border-color: #1e1e1e;
}
:deep(.el-checkbox__label){
  color: #1E1E1E!important;
}
.form-title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #1E1E1E;
    line-height: 42px;
    text-align: center;
    margin: 30px 0;
}

.el-form-item__label {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #252323;
    line-height: 21px;
    padding-right: 0 !important;
}

.el-form-item__content {
    width: 100%;
    height: 56px;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
}

.el-select {
    width: 100%;
}

.el-input,
.el-input>input {
    height: 56px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 10px;
}

.form-tip {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #1E1E1E;
    line-height: 21px;
}

.form-remark {
    font-family: MicrosoftYaHei;
    font-size: 16px;
    color: #959595;
    line-height: 21px;
    text-align: left;
    margin-bottom: 40px;
}

.form-tip>>>.el-checkbox__label {
    padding-left: 5px !important;
}

.form-tip>>>.el-checkbox {
    margin-right: 15px !important;
}

.custom-button {
    background: #1E1E1E;
    border-radius: 10px;
    font-size: 1vw;
    padding: 0.5vw 1.5vw;
    border-color: #1E1E1E;
    margin-bottom: 8%;
}
.algin-center {
    align-items: center;
}

.social-links {
    display: flex;
    gap: 1vw;
    align-items: center;
}

.social-links a {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    text-decoration: none;
}

.social-links a img {
    width: 35px;
    height: 35px;
}

.social-links span {
    width: 119px;
    height: 1px;
    border: 1px solid #1E1E1E;
    margin-left: 27px;
}
:deep(.el-checkbox__label){
    color: #606266 !important;
    font-weight: 100!important;
    font-size: 1vw!important;
}
:deep(.el-form-item__label){
    font-size: 1vw!important;
    font-family: MicrosoftYaHei;
}
</style>